// extracted by mini-css-extract-plugin
export default {"delete":"styles_delete__1EEjX"};